import HistoryLayout from './HistoryLayout';

// TODO: replace with HistoryProperties compoent and remove this #794
const HistoryProperty = (props) => {
  return <HistoryLayout id={props.id} object={props.object} />;
};

export default HistoryProperty;
